import React from 'react'
import { Text } from 'react-native-paper'
import { StyleSheet, TouchableOpacity, View } from 'react-native'
import { commonColors } from '@linqpal/common-frontend/src/theme/colors'
import { Status } from './Status'
import { statusBadge } from '@linqpal/models/src/dictionaries/invoiceStatus'
import { useTranslation } from 'react-i18next'

export const InvoiceListItem = ({
  onPress,
  title,
  subtitle,
  status,
  amount,
  style,
  embeddedButton = undefined,
  disabled = false,
  isFactoring = false,
  type = '',
}) => {
  const height = embeddedButton ? 'auto' : 80
  return (
    <TouchableOpacity
      style={{
        padding: 16,
        height: height,
        borderWidth: 1,
        borderColor: '#E6EBEE',
        borderRadius: 12,
        ...style,
      }}
      disabled={disabled}
      onPress={onPress}
    >
      <View style={{ flexDirection: 'row' }}>
        <View style={{ flex: 1, justifyContent: 'center' }}>
          <Text
            numberOfLines={1}
            ellipsizeMode="tail"
            style={{
              fontWeight: '500',
              fontSize: 16,
              color: commonColors.textDark,
            }}
          >
            {title}
          </Text>
          <Text
            style={{
              fontWeight: '500',
              fontSize: 12,
              color: commonColors.textLight,
              marginVertical: 6,
            }}
          >
            {subtitle}
          </Text>
        </View>
        <View style={{ flexDirection: 'column', alignItems: 'flex-end' }}>
          <Text style={{ fontWeight: '500', fontSize: 16, color: '#003353' }}>
            $ {amount}
          </Text>
          <View style={styles.rowContainer}>
            {type && !isFactoring ? <InvoiceTypeBadge type={type} /> : null}
            <Status
              label={statusBadge[status]?.label}
              textColor={statusBadge[status]?.textColor}
            />
          </View>
        </View>
      </View>
      <View style={{ paddingTop: 16 }}>{embeddedButton}</View>
    </TouchableOpacity>
  )
}

const colors = {
  quote: { borderColor: '#003353', color: '#003353' },
  invoice: { borderColor: '#00A0F3', color: '#00A0F3' },
  other: { borderColor: '#0070AA', color: '#0070AA' },
}

function InvoiceTypeBadge({ type }) {
  const { t } = useTranslation('global')
  const borderColor = colors[type]?.borderColor || colors.other.borderColor
  const color = colors[type]?.color || colors.other.color
  return (
    <View style={[styles.typeWrapper, { borderColor }]}>
      <Text style={[styles.typeLabel, { color }]}>{t(type)}</Text>
    </View>
  )
}

const styles = StyleSheet.create({
  rowContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  typeWrapper: {
    borderRadius: 5,
    borderWidth: 1,
    justifyContent: 'center',
    alignItems: 'center',
    height: 22,
    marginRight: 6,
    paddingHorizontal: 12,
  },
  typeLabel: {
    fontSize: 11,
    fontWeight: '500',
    lineHeight: 20,
  },
})
